const { Fragment, useState, useEffect, useRef } = wp.element;

import { __ } from "@wordpress/i18n";
import PresetModal from "./PresetModal";
import Preview from "./Preview";
import Settings from "./Settings";
import Uploader from "./Uploader";

function Edit(props) {
  const { attributes, setAttributes, clientId } = props;
  const { uniqueId, file = pdfp?.placeholder, additional, adobeOptions } = attributes;

  const [modalOpen, setModalOpen] = useState(false);
  const [preset, setPreset] = useState({ preset: attributes });

  //generate new unique ID
  useEffect(() => {
    setAttributes({ uniqueId: "pdfp" + clientId.substr(0, 8) });
    setAttributes({ adobeOptions: { ...adobeOptions, updated: true } });
  }, []);

  if (!file) {
    return <Uploader attributes={attributes} setAttributes={setAttributes} />;
  }

  return (
    <Fragment>
      <style>{additional?.CSS}</style>
      <Settings setModalOpen={setModalOpen} {...props} setPreset={setPreset} />
      <Preview {...props} />
      {pdfp?.pipe && <>{modalOpen && <PresetModal preset={preset} setPreset={setPreset} setModalOpen={setModalOpen} {...props} />}</>}
    </Fragment>
  );
}

export default Edit;
